import { Col, Row, Button } from 'antd';
import React from 'react';
import './WebhooksInfo.scss';
import { ReactSVG } from 'react-svg';

const WebhooksInfo = ({ webhook = {}, onClickEdit, onClickDelete }) => {
  return (
    <div className="WebhooksInfo">
      <Row gutter={16}>
        <Col span={19}>
          <div className="content">
            <h4>{webhook.event}</h4>
            <p>{webhook.webhookURL}</p>
          </div>
        </Col>
        <Col span={5}>
          <div className="right">
            <div className="actions">
              <Button type="link" className="edit" onClick={onClickEdit}>
                <ReactSVG className="icon" src="/icons/edit.svg" />
              </Button>
              <Button type="link" className="delete" onClick={onClickDelete}>
                <ReactSVG className="icon" src="/icons/delete.svg" />
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default WebhooksInfo;
